import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'lib-app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.css'],
    standalone: false
})
export class AppFooterComponent implements OnInit {

  @Input() red = false;

  constructor() { }

  ngOnInit() {
  }

}
